import classNames from 'classnames'
import React from 'react'
import { FieldErrors } from 'react-hook-form'

interface InputProps {
    title: string
    errors: FieldErrors
}

type InputWithLabelProps = React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
> &
    InputProps

export const Input: React.FC<InputWithLabelProps> = React.forwardRef(
    ({ errors, title, name, required, className, ...inputProps }, ref) => {
        const error = errors[name as string]

        const cls = classNames(
            `p-2 rounded border ${error ? 'border-red-500 bg-red-200' : 'border-gray-500'}  w-full`,
            className
        )

        return (
            <div>
                <label htmlFor={inputProps.id}>
                    {title}
                    {required && <span className="text-red-500">*</span>}
                </label>
                <input {...inputProps} name={name} ref={ref} className={cls} />
                {error && (
                    <small className="text-red-500">
                        {(error.message as string) || 'กรุณาระบุ'}
                    </small>
                )}
            </div>
        )
    }
)
